// extracted by mini-css-extract-plugin
export default {"Navbar":"MainMenu_Navbar__oCBLK","NavbarBrand":"MainMenu_NavbarBrand__O2Hu2","NavLink":"MainMenu_NavLink__sPkA4"};